import ExposedVisitList from "."
import { compose } from "recompose"
import { graphql } from "@apollo/client/react/hoc"
import gql from "graphql-tag"

const ExposedVisitListEnhanced = compose(
  graphql(
    gql`
      query ContactTracingExposedEmployeeVisits(
        $userId: ID!
        $startAt: String!
        $endAt: String!
      ) {
        user(id: $userId) {
          id
          contactTracingVisits(startAt: $startAt, endAt: $endAt) {
            edges {
              node {
                id
                duration
                unit {
                  id
                  name
                }
                location {
                  id
                  name
                }
                entryAt
                exitAt
              }
            }
          }
        }
      }
    `,
    {
      options: ({ userId, startAt, endAt }) => ({
        variables: { userId, startAt, endAt },
      }),
      props: ({ data: { error, loading, user } }) => {
        if (error) throw error
        if (loading) return { loading }

        return {
          visits: user.contactTracingVisits.edges.map((edge) => ({
            id: edge.node.id,
            duration: edge.node.duration,
            unit: edge.node.unit.name,
            name: edge.node.location.name,
            locationId: edge.node.location.id,
            entryAt: edge.node.entryAt,
            exitAt: edge.node.exitAt,
          })),
        }
      },
    }
  )
)(ExposedVisitList)

export default ExposedVisitListEnhanced
